
import bytes from 'bytes'
import _ from 'lodash'
import { Component } from 'react'

import http from '../../../lib/http'
import { LinearProgress, Button } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'

const styles = {
  errors: {
    fontSize: '12px',
    lineHeight: '12px',
    color: 'rgb(244, 67, 54)',
    marginTop: '8px',
    height: '12px'
  },
  target: {
    border: 'dashed grey 4px',
    backgroundColor: 'rgba(255,255,255,.8)',
    position: 'absolute',
    height: '70%',
    width: '94%',
    top: '4%',
    left: '3%',
    zIndex: 99
  },
  text: {
    position: 'absolute',
    top: '50%',
    right: 0,
    left: 0,
    textAlign: 'center',
    color: 'grey',
    fontSize: 36
  }
}

export const defaultFileTypes = {
  'image/jpeg': 'JPEG',
  'image/gif': 'GIF',
  'image/png': 'PNG',
  'application/pdf': 'PDF'
}

export const documentsFileTypes = {
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'DOCX',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX'
}

let fileType = defaultFileTypes

export class FileField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      drag: false,
      uploading: false
    }

    if (props.fileTypes === 'docs') {
      fileType = {
        ...fileType,
        ...documentsFileTypes
      }
    }
    this.fileInput = { current: this.props.fileRef?.current }
  }

  handleDragIn = e => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter++
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true })
    }
  }

  handleDragOut = e => {
    e.preventDefault()
    e.stopPropagation()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.setState({ drag: false })
    }
  }

  handleDrop = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ drag: false })
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.fileInput.current.files = e.dataTransfer.files
      this.handleInputChange(e.dataTransfer.files[0])
      this.dragCounter = 0
    }
  }

  componentDidMount () {
    this.dragCounter = 0
  }

  handleDrag = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  doUpload = () => {
    const { clientName } = this.state

    if (
      !this.isFileSelected() ||
      _.get(this.getFile(), 'size', 0) > (this.props.maxSize || 104857600)
    ) {
      return Promise.resolve({})
    }

    const file = _.get(this.fileInput.current, 'files[0]')
    const formData = new FormData()

    formData.append('file0', file, file.name)

    this.setState({ uploading: true })

    return http
      .postRequest('/documents', formData, {
        clientName
      })
      .then(uploadedFiles => {
        this.setState({ uploading: false })
        return Promise.resolve(uploadedFiles)
      })
      .catch(e => {
        this.setState({ uploading: false })
        throw new Error(_.get(e, 'response.data.error'))
      })
  }

  clear = () => {
    const { onChange } = this.props
    if (onChange) {
      onChange(null)
    }
    this.fileInput.current.value = ''
    this.setState({ previewUrl: null })
  }

  handleInputChange = () => {
    const { onChange } = this.props

    const file = _.get(this.fileInput.current, 'files[0]')
    if (file) {
      const { type } = file

      if (
        type === 'image/gif' ||
        type === 'image/png' ||
        type === 'image/jpeg'
      ) {
        const reader = new FileReader()
        reader.onloadend = () => {
          this.setState({ previewUrl: reader.result })
        }

        reader.readAsDataURL(file)
      }
    }
    this.forceUpdate()

    if (onChange) {
      onChange(this.getFile())
    }
  }

  isFileSelected = () => {
    const file = this.getFile()
    return !_.isNil(file) && !_.isNil(fileType[file.type])
  }

  getFile = () => {
    const file = _.get(this.fileInput?.current, 'files[0]')
    if (_.isNil(file)) {
      return null
    }

    return {
      type: file.type,
      size: file.size,
      name: file.name
    }
  }

  renderFileDetails = () => {
    const { previewUrl } = this.state
    const file = _.get(this.fileInput.current, 'files[0]')
    const type = fileType[file.type] || (
      <span style={{ color: 'red' }}>Unsupported file type</span>
    )
    const size = _.get(file, 'size')
    const name = _.get(file, 'name')

    let preview

    if (previewUrl) {
      preview = (
        <img
          src={previewUrl}
          width='120'
          alt={name}
        />
      )
    } else {
      preview = _.truncate(name, { length: 20 })
    }

    return (
      <table className='accordionTable'>
        <tbody>
          <tr>
            <td>{preview}</td>
            <td>{bytes(size)}</td>
            <td>{type}</td>
            <td>
              <button
                style={{
                  cursor: 'pointer',
                  color: 'red'
                }}
                onClick={this.clear}
              >
                <i className='fa fa-remove' />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  openFileDialog = () => {
    this.fileInput.current?.click()
  }

  render () {
    const { uploading, drag } = this.state
    let { errors, maxSize } = this.props
    const file = this.getFile()
    maxSize = maxSize || 104857600

    const fileSize = _.get(file, 'size', 0)
    if (fileSize > maxSize) {
      errors = errors || [ `File is larger than ${maxSize / (1024 * 1024)} Mb` ]
    }

    let componentBody = null
    let progress = null
    const input = (
      <input
        type='file'
        style={{ display: 'none' }}
        onChange={this.handleInputChange}
        ref={this.fileInput}
      />
    )

    if (uploading) {
      progress = <LinearProgress style={{ marginBottom: '20px' }} />
    }

    if (_.isNil(file)) {
      componentBody = (
        <Button
          purple
          onClick={this.openFileDialog}
          style={{ marginTop: '24px' }}
          label=''
        >
          <span>Select or Drag&Drop a file </span>
        </Button>
      )
    } else {
      componentBody = this.renderFileDetails()
    }

    return (
      <div
        className={`file-uploader ${!_.isNil(file) && 'file-choosen'}`}
        onDragOver={this.handleDrag}
        onDrop={this.handleDrop}
        onDragLeave={this.handleDragOut}
        onDragEnter={this.handleDragIn}
      >
        {drag && (
          <div
            className='drop-target'
            style={styles.target}
          >
            <div
              className='text'
              style={styles.text}
            >
              <div>Drop file here</div>
            </div>
          </div>
        )}
        {progress}
        {componentBody}
        {input}
        {errors ? <div style={styles.errors}>{errors[0] || ' '}</div> : null}
      </div>
    )
  }
}

export const FileInput = makeAutobindedInput(FileField)
